export default __webpack_public_path__ + "static/media/close-grey.25b4d4c2.svg";